module.exports = __webpack_public_path__ + "img/TJ.b3a06694.svg";